import Vue from 'vue'
import config from '@/config/index'

export default {
	namespaced: true,
	actions: {
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/sectionDepartments`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/sectionDepartments/page/${pagination.sectionId}`, { params: pagination })
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem', payload)
      return Vue.axios.get(`${config.serverURI}/sectionDepartments/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/sectionDepartments`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/sectionDepartments/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/sectionDepartments/${payload.id}`)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/sectionDepartment.js